import type MenuI from '@/types/Navigation/MenuI'
import type MenuItemI from '@/types/Navigation/MenuItemI'
import fetchGql from '@/utils/fetchGql'
import { useCacheStorage } from '@/composables/useSessionStorage'
import { isEn } from '@/utils/helpers'

const { getCache } = useCacheStorage()

const query = gql`
  query MenuItems($language: String) {
    MenuItems(starts_with: $language, resolve_links: "url", by_slugs: "corporate/shared/about-us-menu") {
      items {
        content {
          items
        }
      }
    }
  }
`

const getMenuData = (item: MenuItemI, locale: string) => {
  let target = '_self'
  let key = formatSbPath(item.redirect?.story?.full_slug, locale) || '/'

  if (item.redirect?.linktype === 'url') {
    key = item.redirect.url
  }

  if (item.redirect?.target) {
    target = item.redirect.target
  }

  const data = {
    title: item.title,
    key,
    target,
    enData: {
      name: item.redirect?.story?.name || '',
      slug: item.redirect?.story?.slug || ''
    }
  }

  return data
}

const parseData = (data: any, locale: string) => {
  const result: MenuI[] = []

  data[0].content.items.forEach((menuItem: MenuItemI) => {
    if (menuItem.subItems?.length) {
      const parsedItems: MenuI[] = []
      menuItem.subItems.forEach((item: MenuItemI) => {
        parsedItems.push({
          ...getMenuData(item, locale)
        })
      })

      result.push({
        ...getMenuData(menuItem, locale),
        subItems: parsedItems
      })
    } else {
      result.push({
        ...getMenuData(menuItem, locale)
      })
    }
  })

  return result
}

export const useFetchMenu = () => {
  const fetchMenu = async (language: string) => {
    const cache = await getCache(`company-menu-${language}`)

    const variables = {
      language: isEn(language) ? '' : `${language}/*`
    }

    if (cache.value.data) return cache.value.data

    return fetchGql(query, variables).then(async (response: any) => {
      return (cache.value.data = parseData(response.MenuItems.items, variables.language))
    })
  }

  return { fetchMenu }
}
